<template>
  <div class :class="['cookie-container', hide ? 'chide' : '']">
    <div class="close-box" @click="closeBox">
      <div class="close" data-test="CookieMessage-crossIcon"></div>
    </div>
    <div class="content">
      <span>基于功能和数据分析需求，我们的网站使用（包括第三方的）cookies，来收集信息和存储您的在线偏好，为您提供更加个性化的体验和内容，并用于分析广告活动的表现。当您继续浏览本站时，即表示您同意我们使用cookies。如想了解更多信息，或调整cookie设置，请点击</span>
      <a class="link" data-test @click="goRouter('/privacy')">此处 。</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "User",
  data() {
    return {
      hide: false,
      flodlerName: ""
    };
  },
  props: {
    showList: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  methods: {
    goRouter(_r) {
      this.$router.push({ path: _r });
    },
    closeBox() {
      this.hide = true;
      this.setCookie("set_cookie", "0", 730);
      window.localStorage.setItem("set_cookie", "0");
      setTimeout(() => {
        this.$emit("closeBox");
      }, 300);
    },
    setCookie(name, value, days) {
      //设置cookie
      var d = new Date();
      d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toGMTString();
      document.cookie = name + "=" + value + "; " + expires;
    }
  }
};
</script>
<style lang="less" scoped>
.cookie-container {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 150;
  padding: 0;
  transform: translateZ(0);
  opacity: 1;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  &.chide {
    transition: transform 0.3s, opacity 0.3s;
    opacity: 0;
  }
  .close-box {
    position: absolute;
    // top: 1.5rem;
    margin-left: 1rem;
    cursor: pointer;
    .close {
      position: relative;
      width: 2rem;
      height: 2rem;
      &::after,
      &::before {
        content: "";
        position: absolute;
        top: 50%;
        right: 0;
        left: 0;
        height: 0.2rem;
        display: block;
        border-radius: 0.2rem;
        transform-origin: top;
        background-color: #fff;
        z-index: 9;
      }
      &::before {
        transform: rotate(-45deg) translateY(-50%);
      }
      &::after {
        transform: rotate(45deg) translateY(-50%);
      }
    }
  }

  .content {
    position: relative;
    padding: 1.5rem 3rem 1.5rem 3.5rem;
    opacity: 0.9;
    color: #fff;
    background-color: #000;
    width: 100%;
    // min-height: 5rem;
    justify-content: center;
    align-items: center;
    text-align: center;

    .link {
      color: #fff;
      text-decoration: underline;

      &:hover {
        color: gray;
        transition: color 0.3s linear;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/CookieSet.vue